import { Dispatch } from '@reduxjs/toolkit'
import { AffiliateApiClient } from 'utils/api/affiliateApi'

import { affiliateSlice } from './affiliate.slice'

export const fetchAffiliateCountries = (affiliateApiClient: AffiliateApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await affiliateApiClient.getAffiliateCountries()
      dispatch(affiliateSlice.actions.setAffiliateCountries(response))
    } catch (error) {
      console.error("Couldn't fetch the affiliate countries.", error)
    }
  }
}

export const fetchAffiliateTypes = (affiliateApiClient: AffiliateApiClient) => {
  return async (dispatch: Dispatch): Promise<void> => {
    try {
      const response = await affiliateApiClient.getAffiliateTypes()
      dispatch(affiliateSlice.actions.setAffiliateTypes(response))
    } catch (error) {
      console.error("Couldn't fetch the affiliate types.", error)
    }
  }
}
